import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL;

let instance = axios.create({
  baseURL: API_URL,
  timeout: 6000,
});

export default {
  instance,
  get(uri) {
    return instance.get(uri, { headers: {
        "Content-Type":"application/json"
      }
    });
  },
  post(uri, body) {
    return instance.post(uri, body, { headers: {
      "Content-Type":"application/json"
    }});
  },
  patch(uri, body) {
    return instance.patch(uri, body, { headers: {
      "Content-Type":"application/json"
    }});
  },
};
